// extracted by mini-css-extract-plugin
export default {"component":"noteDialog__component___jb8h2","formComponent":"noteDialog__formComponent___+nYWt","textField":"noteDialog__textField___YpCLw"};